module.exports = __webpack_public_path__ + "img/watt.96ed9362.svg";